import { createSelector } from '@ngrx/store';

import { selectPublicHealthRecordTypeState } from '../../../core.state';

export const selectPublicHealthRecordTypes = createSelector(
    selectPublicHealthRecordTypeState,
    state => state.items
);

export const selectPublicHealthRecordTypesLoaded = createSelector(
    selectPublicHealthRecordTypeState,
    state => state.loaded
);
